import React, {Component} from 'react';
import {connect} from 'react-redux';
import {modeEmail}  from '../../../AnimalList/actions/actionsAnimalList';
import {changeTipo, changeAsunto} from '../../actions/actionsContactByEmail'
import Alert from 'react-s-alert';


class OLD_Contact extends Component {


    constructor(props) {
        super(props);
        this.showEmail = this.showEmail.bind(this);
        this.whatsappEvent = this.whatsappEvent.bind(this);
        this.sendEventWhatsapp = this.sendEventWhatsapp.bind(this);

        this.props.configEstadoContacto.methodChange = this.changeAsunto.bind(this);

    }

    changeAsunto(asunto){
        //console.log("OLD_Contact::changeAsunto()");
        if (asunto !== undefined) {
            this.props.changeAsunto(asunto[0], this.props.animalsControl);
        }
    }

    showEmail() {
        this.props.changeModeEmail(true, this.props.animalsControl);
    }

    whatsappEvent() {
        const infoPortectora = this.props.infoAnimalDetail.protectora || this.props.infoProtectoraDetail
        const colaboradores = infoPortectora.colaboradores.filter((telefono)=>{
            return telefono.WhatsApp
        });
        if (colaboradores.length === 0) {
            Alert.info('Esta protectora no tiene whatsapp :(', {
                position: 'top-right',
                effect: 'slide',
                timeout: 6000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "lab la-whatsapp la-2x"
                }
            });
        } else {
            Alert.info('Seleccione el número', {
                position: 'top-right',
                effect: 'slide',
                timeout: 'none',
                customFields: {
                    messageItem: 4,
                    showIconClosed: true,
                    icon: "lab la-whatsapp la-2x",
                    colaboradores: colaboradores,
                    methodWhatsapp: this.sendEventWhatsapp
                }
            });
        }
    }

    sendEventWhatsapp(number) {
        //console.log("OLD_Contact::sendEventWhatsapp()");
        const urlWhats = number 
            ? "https://wa.me/34" + number + "?text=" + this.props.optionsEmail.asunto 
            : "https://wa.me/?text=" + this.props.optionsEmail.asunto;
    
        window.open("https://wa.me/34" + number + "?text=" + this.props.configEstadoContacto.messageWhatsapp + "%20" + this.props.urlWhastapp);
    }

    showStep1() {
        //console.log("OLD_Contact::showStep1()");
        const animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        this.props.changeModeEmail(false, this.props.animalsControl);

        var that = this;
        $('.contactStep2').removeClass("animated-400ms fadeInLeft").addClass('animated-400ms flipOutX').one(animationEnd, function () {
            $('.contactStep2').hide();
            $(that.props.configEstadoContacto.divSelect).addClass("animated-400ms fadeInLeft");
            $('.botonStep1Contacto').addClass("animated-400ms fadeInRight");
            $('.contactStep1').show();
            $('.contactStep2').off(animationEnd);

            var nav = "";
            var animateTime = 100;
            if (typeof that.props.divnav === 'undefined') {
                if (that.props.tabInfoDetail === 0) {
                    nav = $('.cardAnimalDetail');
                } else if (that.props.tabInfoDetail === 1) {
                    nav = $('.cardImagenesYVideos');
                } else if (that.props.tabInfoDetail === 2) {
                    nav = $('.cardProtectoraDetail');
                }
            } else {
                nav = $(that.props.divnav);
            }
            //that.autoHeightAnimate(nav, animateTime);
        });
    }

    showStep2() {
        //console.log("OLD_Contact::showStep2()");
        const animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

        var that = this;

        $('.contactStep1').addClass('animated-400ms flipOutX').one(animationEnd, function () {
            $('.contactStep1').hide();
            $('.contactStep1').removeClass("animated-400ms flipOutX").off(animationEnd);

            $('.contactStep2').removeClass('animated-400ms flipOutX');
            $('.contactStep2 a').addClass('animated-400ms fadeInRight');
            $('.contactStep2 p').addClass('animated-400ms fadeInLeft');

            $('.contactStep2').show();

            var nav = "";
            var animateTime = 100;
            if (typeof that.props.divnav === 'undefined') {
                if (that.props.tabInfoDetail === 0) {
                    nav = $('.cardAnimalDetail');
                } else if (that.props.tabInfoDetail === 1) {
                    nav = $('.cardImagenesYVideos');
                } else if (that.props.tabInfoDetail === 2) {
                    nav = $('.cardProtectoraDetail');
                }
            } else {
                nav = $(that.props.divnav);
            }
            //that.autoHeightAnimate(nav, animateTime);

        });
    }

    render() {
        return (
            <div className="">
                <h4>Pedir información</h4>
                <div className="contact-mode">
                    <a onClick={this.whatsappEvent} href="#" className="socialCircle shadow-hover">
                        <span className="lab la-whatsapp"/>
                    </a>
                    <a onClick={this.showEmail} href="#" className="socialCircle shadow-hover">
                        <span className="las la-envelope"/>
                    </a>
                </div>
            </div>
        );
    }

    componentDidMount() {
        $('.contactStep2').show();

        const {changeTipo, changeAsunto, configEstadoContacto, animalsControl} = this.props;
        changeTipo(configEstadoContacto.tipo, animalsControl);
        // changeAsunto($(`#${configEstadoContacto.idSelect}`).select2('data')[0].text, animalsControl);
        // changeAsunto($(`#contactoAnimal`).select2('data')[0].text, animalsControl);
        // console.log("configEstadoContacto.idSelect = '" + configEstadoContacto.idSelect + "'");
    }

    // autoHeightAnimate(element, time){
    //     var curHeight = element.height(); // Get Default Height
    //     var autoHeight = element.css('height', 'auto').height(); // Get Auto Height
    //     element.height(curHeight); // Reset to Default Height
    //     element.stop().animate({ height: autoHeight }, time);
    // }

}

function mapStateToProps(state, ownProps) {
    return {
        infoProtectoraDetail: state[ownProps.animalsControlDetail].infoProtectoraDetail,
        infoAnimalDetail: state[ownProps.animalsControlDetail].infoAnimalDetail,
        optionsEmail: state.contactByEmail,
        tabInfoDetail: state[ownProps.animalsControlDetail].tabInfoDetail
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {changeTipo, changeAsunto})(OLD_Contact)
